module.exports = __webpack_public_path__ + "static/img/suport-p-1.92360b3.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/suport-p-1.png
// module id = yXI5
// module chunks = 0